import isWindowsPhone from './isWindowsPhone';

const isSymbian = (): boolean => {
  return /(?:SymbianOS)/.test(navigator.userAgent) || isWindowsPhone();
};

export default isSymbian;
